import { useData, useDispatch } from "./DataContext.js";

import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

import { XLg } from "react-bootstrap-icons";

export default function StudentCard (props)
{
    const gData = useData();
    const gDispatch = useDispatch();
    if (gData.student[props.studentID] === undefined) return (<></>);

    const student = gData.student[props.studentID];
    const studentName = student.name;

    function handleDeleteStudent ()
    {
	gDispatch({ type: "delete", table: "student", id: props.studentID });
    }
    
    return (
	<ButtonGroup>
	    <Button variant="outline-dark" size="md" className="pe-none">{studentName}</Button>
	    <Button variant="outline-secondary" size="md" onClick={handleDeleteStudent}><XLg/></Button>
	</ButtonGroup>
    );
}
